import { CssBaseline, ThemeProvider, Typography } from "@mui/material";
import { BrowserRouter, Navigate, Route, Routes, useSearchParams } from "react-router-dom";
import Layout from "./Layout";
import Chess from "./pages/chess/Chess";
import Dashboard from "./pages/Dashboard";
import theme from "./theme";
import Devices from "./pages/devices/Devices";
import { AuthProvider } from "./pages/chess/lichess/LichessAuth";
import { DeviceProvider } from "./pages/devices/DeviceProvider";

const RootRoute = () => {
  const [searchParams] = useSearchParams();
  if (searchParams.has('code') || searchParams.has('error')) {
    return <Navigate to={`/connect?${searchParams.toString()}`} replace />;
  }
  return <Navigate to="/home" replace />;
};

function App() {
  return (
    <>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <DeviceProvider>
          <AuthProvider lichessHost="https://lichess.org">
            <BrowserRouter>
              <Layout>
                <Routes>
                  <Route path="/" element={<RootRoute />} />
                  <Route path="/home" element={<Dashboard />} />
                  <Route path="/connect" element={<Chess />} />
                  <Route path="/scanner" element={<Devices />} />
                  <Route path="*" element={<Typography>Page not found.</Typography>} />
                </Routes>
              </Layout>
            </BrowserRouter>
          </AuthProvider>
        </DeviceProvider>
      </ThemeProvider>
    </>
  );
}

export default App;
